<template>
    <div class="d-inline-block">
        <div :id="targetId" class="share-percent" :style="background ? { background } : null">
            <div
                v-for="(value, index) in values"
                :key="`${index}-${String(value)}`"
                class="percent-indicator"
                :style="{
                    width: getWidthPercent(index),
                    background: getColor(index),
                }"
            ></div>
        </div>

        <b-tooltip :target="targetId" placement="left" triggers="hover focus" boundary="viewport" custom-class="share-tooltip">
            <div class="share-wrapper">
                <div v-for="(_, index) in values" :key="`tooltip-${index}`" class="share-item">
                    <div class="share-color" :style="{ background: getColor(index) }"></div>
                    <div class="share-label">{{ getLabel(index) }}</div>
                </div>
            </div>
        </b-tooltip>
    </div>
</template>

<script>
    export default {
        name: 'ShareMultiple',
        props: {
            values: {
                type: Array,
                required: true,
            },
            labels: {
                type: Array,
                default: () => [],
            },
            colors: {
                type: Array,
                default: () => [],
            },
            valueFormatter: {
                type: Function,
                default: null,
            },
            background: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                targetId: `share-multiple-${Math.random().toString(36).slice(2)}`,
                defaultColors: ['#3366cc', '#dc3912', '#ff9900', '#109618', '#990099', '#0099c6', '#dd4477', '#66aa00', '#b82e2e', '#316395'],
            };
        },
        computed: {
            total() {
                return this.values.reduce((sum, raw) => sum + (Number.isFinite(+raw) ? +raw : 0), 0);
            },
        },
        methods: {
            toNumber(raw) {
                const number = Number(raw);
                return Number.isFinite(number) ? number : 0;
            },
            getValue(index) {
                return this.toNumber(this.values[index]);
            },
            getValueFormatted(index) {
                return typeof this.valueFormatter === 'function' ? this.valueFormatter(this.getValue(index)) : this.getValue(index);
            },
            getPercentNumber(index) {
                const base = this.total || 1;
                return (this.getValue(index) / base) * 100;
            },
            getPercentText(index) {
                const pct = Math.round(this.getPercentNumber(index) * 10) / 10;
                return this.$format.percent(pct);
            },
            getWidthPercent(index) {
                const pct = Math.round(this.getPercentNumber(index) * 10) / 10;
                return `${pct}%`;
            },
            getLabel(index) {
                const template = this.labels[index] || '{{value}} ({{valuePercentFormatted}})';
                return template
                    .replace('{{value}}', this.getValue(index))
                    .replace('{{valuePercent}}', this.getPercentNumber(index))
                    .replace('{{valuePercentFormatted}}', this.getPercentText(index))
                    .replace('{{valueFormatted}}', this.getValueFormatted(index));
            },
            getColor(index) {
                return this.colors[index] || this.defaultColors[index % this.defaultColors.length];
            },
        },
    };
</script>

<style scoped lang="scss">
    .share-percent {
        display: inline-flex;
        flex-wrap: nowrap;
        overflow: hidden;
        justify-content: flex-start;
        align-items: center;
        width: 52px;
        height: 10px;
        background: #fff;
        border-radius: 2px;
    }
    .percent-indicator {
        height: 100%;
    }
    .share-wrapper {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }
    .share-item {
        display: flex;
        align-items: baseline;
        text-align: left;
    }
    .share-color {
        flex-grow: 0;
        width: 10px;
        height: 10px;
        margin-right: 4px;
    }
    .share-label {
        flex-grow: 1;
    }
    ::v-deep .share-tooltip .tooltip-inner {
        text-align: left;
        max-width: 320px;
    }
</style>
